import { render, staticRenderFns } from "./EditWiki.vue?vue&type=template&id=02920f3c&scoped=true&"
import script from "./EditWiki.vue?vue&type=script&lang=js&"
export * from "./EditWiki.vue?vue&type=script&lang=js&"
import style0 from "./EditWiki.vue?vue&type=style&index=0&id=02920f3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02920f3c",
  null
  
)

export default component.exports